import { TStates } from '@Managers/StateMachine/StateMachine.types';
import { winPresentationIdleResolver, winHoldStateResolver, winPresentationOutResolver, completeWinPresentationResolver } from './WinPresentationResolvers';
import { EWinPresentationStates } from './WinPresentationStates';

export const WinPresentationStatesDefault: TStates<EWinPresentationStates> = {
    WIN_PRESENTATION_HIDDEN_STATE: {},
    PRE_WIN_PRESENTATION_STATE: {},
    WIN_PRESENTATION_IN_STATE: {},
    WIN_PRESENTATION_IDLE_STATE: { resolver: winPresentationIdleResolver },
    WIN_PRESENTATION_HOLD_STATE: { resolver: winHoldStateResolver },
    WIN_PRESENTATION_OUT_STATE: { resolver: winPresentationOutResolver },
    POST_WIN_PRESENTATION_STATE: { resolver: completeWinPresentationResolver }
};
